
type GraphQLScalarValue = string | number | boolean | null;
interface GraphQLVariables {
    [key: string]: GraphQLScalarValue | GraphQLVariables | GraphQLScalarValue[] | GraphQLVariables[];
}

interface FetchGraphQLProps {
    url: string;
    query: string;
    variables?: GraphQLVariables;
}

export const fetchGraphQL = async ({ url, query, variables = {} }: FetchGraphQLProps) => {
    const token = sessionStorage.getItem('state');
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                ...token && {
                    Authorization: token,
                }
            },
            body: JSON.stringify({ query, variables })
        });
        const jsonResponse = await response.json();
        if (jsonResponse.errors) {
            throw new Error(jsonResponse.errors.map((err: any) => err.message).join(', '));
        }
        return { data: jsonResponse.data };
    } catch (error) {
        return { error };
    }
}